import styled from 'styled-components';

export const ExportTitleWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  font-size: 18px;
  font-weight: 500;
`;

export const ExportSubTitle = styled.div`
  font-size: 14px;
  font-weight: 400;
`;

export const ExportCheckboxGroupWrapper = styled.div`
  padding: 0 24px 48px;
  width: 100%;
  font-weight: 600;
`;

export const ExportCheckboxGroupOptions = styled.div`
  width: 100%;
  display: flex;
  flex-flow: row wrap;
`;

export const ExportCheckboxGroupOption = styled.div`
  width: 50%;
  margin: 4px 0;
  font-weight: 400;
`;
